module.exports = __webpack_public_path__ + "plane-blueprint-hazelnut-ice-cream.fbb7ceb123ac56337a6d.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/img/plane-blueprint-hazelnut-ice-cream.svg
// module id = ../../../../../src/assets/img/plane-blueprint-hazelnut-ice-cream.svg
// module chunks = main